import styled from "styled-components";
import * as antd from "antd";
import * as common from "../../_common";

export const BaseForm = styled(common.BaseForm)`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  padding: 40px 30px;

  @media (min-width: 1160px) {
    flex-direction: row;
    justify-content: flex-start;
    padding-bottom: 0;
  }
`;

export const SubmitButton = styled((props) => (
  <antd.Button {...props} type="primary" size="large" />
))`
  background: linear-gradient(#fff, #fff) padding-box,
    linear-gradient(
        42.69deg,
        #fff33b -5.54%,
        #fee72e -1.35%,
        #fed51b 6.72%,
        #fdca10 15%,
        #fdc70c 23.9%,
        #f3903f 64.56%,
        #ed683c 87.51%,
        #e93e3a 99.24%
      )
      border-box;
  color: #313149;
  width: 100%;
  font-size: 18px;
  line-height: 18px;
  margin-top: 30px;

  @media (min-width: 1160px) {
    width: 300px;
  }
`;

export const Col = styled.div<{ flex?: number }>`
  flex: ${(props) => props.flex ?? 1};
  margin: 0 2%;
  padding-top: 20px;

  &:first-child {
    padding-top: 0;
  }

  @media (min-width: 1160px) {
    padding-top: 0;
  }
`;

export const RangePicker = styled(antd.DatePicker.RangePicker)``;
